import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostCategoriesPublicRequestQuery extends AbstractGraphqlRequest<
  PostCategoryModel[]
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findPublicPostCategories(
        $payload: PostCategoryRequestPayloadInput
      ) {
        findPublicPostCategories(payload: $payload) {
          cover {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let items = data.findPublicPostCategories || [];

    return items.map((item: any) => new PostCategoryModel(item));
  }
}
